import { createCache, extractStyle, StyleProvider } from '@ant-design/cssinjs';
import { useLayoutEffect, useState } from 'react';
import { ShadowDomContainer } from './components/ShadowDomContainer';
import { Portal } from 'react-portal';

const cache = createCache();

const BCPortalStyleExtractor: React.FC<{ extractPopupKey: string }> = props => {
	const [styles, setStyles] = useState('');

	useLayoutEffect(() => {
		const generatedStyles = extractStyle(cache, { types: 'style' });
		setStyles(generatedStyles);
	}, []);

	return (
		<StyleProvider cache={cache}>
			{props.children}
			<Portal>
				<ShadowDomContainer containerId={`${props.extractPopupKey}_container`}>
					<div id={props.extractPopupKey}></div>
					<div dangerouslySetInnerHTML={{ __html: styles }} />
				</ShadowDomContainer>
			</Portal>
		</StyleProvider>
	);
};

export { BCPortalStyleExtractor, ShadowDomContainer };
